module.exports = __webpack_public_path__ + "static/media/Upload.2e587929.png";